import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const parts = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const dark = tone === 'dark';
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-23" data-mp="3c3yysrhwio94">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${dark ? 'text-brand-100' : 'text-brand-700'}`} data-id="element-24" data-mp="3h2jzst4z9bym">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="373ugqx1chlgs" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-26" data-mp="10dekfqcbl5v8">
        {parts.map((part, i) => <React.Fragment key={part.label} data-id="element-27" data-mp="15boge35vcahw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-28" data-mp="159bzltbuk66f">
              <span className={`grid h-16 w-16 place-items-center rounded-xl font-display text-3xl font-bold tabular-nums sm:h-[72px] sm:w-[72px] sm:text-4xl ${dark ? 'bg-white text-brand-900' : 'bg-brand-800 text-white'}`} data-id="element-29" data-mp="y04x04zyfork">
                {String(part.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase ${dark ? 'text-brand-200' : 'text-ink-soft'}`} data-id="element-30" data-mp="f2aort6nhha8">
                {part.label}
              </span>
            </div>
            {i < parts.length - 1 && <span className={`pt-3 font-display text-3xl font-bold ${dark ? 'text-white' : 'text-brand-800'}`} data-id="element-31" data-mp="o41wf3kr3y6q">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}